import React from "react";

import Modal from "react-responsive-modal";
import { Tooltip } from "react-tippy";
import UtilityService from "../../../services/UtilityService";

import * as Icon from "react-feather";

import "react-tippy/dist/tippy.css";

import { STATUSES } from "../../../constants/Tasks";

import SearchableDropdown from "../../common/searchable_dropdown/SearchableDropdown";
import UserService from "../../../services/UserService";
import ClientService from "../../../services/ClientService";
import TaskService from "../../../services/TaskService";
import EngagementService from "../../../services/EngagementService";

import TextFieldInput from "../../common/text_field_input/TextFieldInput";
import TextAreaField from "../../common/text_area_field/TextAreaField";
import Checkbox from "../../common/checkbox/Checkbox";
import WComponent from "../../common/WComponent";
import UserAssigner from "../../common/user_assigner/UserAssigner";
import DeleteConfirmationModal from "../../common/modal/confirmation_modal/ConfirmationModal";
import DateSelector from "../../common/date_selector/DateSelector";
import Button from "../../common/button/Button";
import Loader from "../../common/loader/Loader";

import "./task-modal.css";
import "../../common/modal/modal.css";
import PermissionGate from "../../../permissions/permissionGate";
import RequiredLabel from "../../common/required_label";
import DescriptionField from "../../workflow/components/description_field/DescriptionField";

const { alert } = UtilityService;

class TaskModal extends WComponent {
	constructor() {
		super();
		this.state = {
			taskId: "new",
			engagementId: 0,
			clientId: 0,

			name: "",
			description: "",
			deadline: new Date().toDateString(),
			// duration: '',
			notes: "",
			notify: false,
			status: "pending",
			createdBy: 0,
			read: false,

			loading: false,
			show: false,

			selectedClientName: "",
			selectedStatus: "",

			assignedUsers: [],
			showDeleteConfirmation: false,
			description: "",

			// Sequential handoff
			step: 0,
			sequentialTasks: false,
			sentBackReason: "",
			showSendBack: false,
			sendBackDraft: "",
      
			queueForNextRecurring: false,
		};
	}

	componentDidMount = () => {
		this.resetComponent();
	};

	componentDidUpdate = prevProps => {
		let { show } = this.props;

		if (prevProps.show !== show) {
			this.resetComponent();
		}
	};

	resetComponent = async () => {
		let { taskId, clientId, show } = this.props;

		await this.update({
			loading: true
		});

		await this.update({
			// Toggles
			show,

			// Task Data
			taskId,
			clientId: clientId || 0,
			engagementId: 0,
			name: "",
			description: "",
			deadline: new Date().toDateString(),
			// duration: '',
			notes: "",
			status: "pending",
			notify: false,

			// Display Items
			selectedClientName: "",
			selectedStatus: "",

			assignedUsers: [],
			showDeleteConfirmation: false,

			step: 0,
			sequentialTasks: false,
			sentBackReason: "",
			showSendBack: false,
			sendBackDraft: "",
      
			queueForNextRecurring: false
		});

		if (taskId !== "new") {
			await this.fetchTask();
		}

		if (clientId) {
			let client = await ClientService.fetchClient({ clientId });

			await this.update({
				selectedClientName: client.client.name
			});
		}

		await this.update({
			loading: false
		});
	};

	async fetchTask() {
		let { taskId } = this.state;

		let taskIdIntialState = 0;
		if (taskId === taskIdIntialState) {
			return;
		}

		try {
			let task = await TaskService.fetchTask({ taskId });

			let assignedUsers = task.task_users.map(tu => {
				let roleName = tu.Role ? tu.Role.name : "No Role";

				return {
					user_id: tu.user_id,
					role_id: tu.role_id,

					userName: `${tu.User.first_name} ${tu.User.last_name}`,
					roleName,
					should_notify: tu.notifications_only
				};
			});

			await this.update({
				// Task Data
				name: task.name,
				engagementId: task.engagement_id,
				clientId: task.client_id,

				description: task.description,
				deadline: task.deadline,
				// duration: task.duration,
				notes: task.notes,
				status: task.status,
				createdBy: task.created_by,
				notify: task.notify,
				read: task.read,

				// Display Items
				selectedClientName: task.Client ? task.Client.name : "",
				selectedStatus: STATUSES[task.status].name,

				assignedUsers,

				step: task.step,
				sequentialTasks: !!(task.Engagement && task.Engagement.sequential_tasks),
				sentBackReason: task.sent_back_reason || "",
				showSendBack: false,
				sendBackDraft: "",
			});
		} catch (error) {
			console.log(error);
		}
	}

	updateTask = async () => {
		let { taskId, clientId, name, description, deadline, notes, status, notify, assignedUsers } = this.state;
		let { engagementId } = this.props;


		const missing = this.getMissingRequiredFields();
		if (missing.length) {
			alert({ type: "error", text: `Please fill: ${missing.join(", ")}` });
			return null;
		}

		alert({ type: "info", text: "Updating ..." });

		await this.update({
			loading: true
		});

		let task = null;

		try {
			task = await TaskService.update({ taskId, name, engagementId, clientId, description, deadline, notes, status, notify, assignedUsers });

			alert({ type: "success", text: "Updated Successfully!" });
		} catch (error) {
			console.log(error);
			alert({ type: "error", text: "Updated error ..." });
		}

		await this.update({
			loading: false
		});

		return task;
	};

	isValid = () => this.getMissingRequiredFields().length === 0;

	createTask = async () => {
		let { name, assignedUsers, clientId, description, deadline, notes, status, notify, queueForNextRecurring } = this.state;
		let { engagementId } = this.props;

		let created = false;

		const missing = this.getMissingRequiredFields();
		if (missing.length) {
			alert({ type: "error", text: `Please fill: ${missing.join(", ")}` });
			return created;
		}

		await this.update({
			loading: true
		});

		try {
			if (queueForNextRecurring) {
				created = await this.queueTaskForNextRecurring();
			} else {
				await TaskService.create({ name, engagementId, assignedUsers, clientId, description, deadline, notes, status, notify });

				created = true;

				alert({ type: "success", text: "Created Successfully!" });
			}
		} catch (error) {
			alert({ type: "error", text: "Create Error ..." });
		}

		await this.update({
			loading: false
		});

		return created;
	};

	queueTaskForNextRecurring = async () => {
		let { name, assignedUsers, description, deadline } = this.state;
		let { recurringEngagement, onRecurringEngagementUpdated } = this.props;

		let updatedRecurringEngagement = await EngagementService.queueRecurringEngagementItems({
			recurringEngagementId: recurringEngagement.id,
			tasks: [{ name, description, deadline, assignedUsers }]
		});

		if (!updatedRecurringEngagement) {
			alert({ type: "error", text: "Failed to save the task for the next recurring engagement." });
			return false;
		}

		alert({ type: "success", text: "Task saved! It will be added to the next recurring engagement." });

		if (onRecurringEngagementUpdated) {
			onRecurringEngagementUpdated(updatedRecurringEngagement);
		}

		return true;
	};

	isNewTask = () => {
		let { taskId } = this.state;
		return taskId === "new";
	};

	onChange = e => {
		let target = e.target;
		let value = target.type === "checkbox" ? target.checked : target.value;

		this.update({
			[target.name]: value
		});
	};

	onStatusSelect = status => {
		this.update({
			status: status.id,
			selectedStatus: status.name
		});
	};

	onClose = async ({ confirmed }) => {
		let task = null;

		if (confirmed) {
			if (this.isNewTask()) {
				let isCreated = await this.createTask();

				if (!isCreated) {
					return;
				}
			} else {
				task = await this.updateTask();
				if (!task) {
					return;
				}
			}
		}

		if (this.props.onClose) {
			// Completing a task in a sequential engagement wakes the next one server-side, tell the host to refetch.
			let refetch = !!(task && this.state.sequentialTasks && task.status === "done");

			this.props.onClose({ task, refetch });
		}
	};

	onDeadlineChange = date => {
		this.update({
			deadline: date
		});
	};

	onClientSelect = client => {
		this.update({
			clientId: client.id,
			selectedClientName: client.name
		});
	};

	deleteTask = async taskId => {
		const { engagementId } = this.state;

		try {
			await TaskService.update({ taskId, engagementId, isDeleted: true });
			this.resetComponent();
		} catch (error) {
			alert({ type: "error", text: "Task Delete Error!" });

			console.error(error);
		}
	};

	// Only the task currently holding the work, with a step before it, can be handed back.
	canSendBack = () => {
		let { sequentialTasks, step, status } = this.state;
		return !this.isNewTask() && sequentialTasks && step > 1 && ["ready", "in_progress"].includes(status);
	};

	onSendBackToggle = () => {
		this.update({ showSendBack: !this.state.showSendBack, sendBackDraft: "" });
	};

	onSendBackDraftChange = event => {
		this.update({ sendBackDraft: event.target.value });
	};

	onSendBackConfirm = async () => {
		let { taskId, sendBackDraft } = this.state;

		if (!sendBackDraft.trim()) {
			alert({ type: "error", text: "Please give a reason for sending this task back." });
			return;
		}

		await this.update({ loading: true });
		const previousTask = await TaskService.sendBack({ taskId, reason: sendBackDraft.trim() });
		await this.update({ loading: false });

		if (!previousTask) {
			alert({ type: "error", text: "Could not send this task back." });
			return;
		}

		alert({ type: "success", text: `Sent back to "${previousTask.name}".` });
		this.props.onClose({ task: previousTask, refetch: true });
	};

	onClickDelete = async () => {
		this.update({
			showDeleteConfirmation: true
		});
	};
	onClickDeleteConfirm = async ({ confirmed, proxyState }) => {
		await this.update({ showDeleteConfirmation: false });

		if (confirmed === false) {
			return;
		}

		const { taskId } = this.state;
		await this.deleteTask(taskId);
		this.onClose({ confirmed: true });
	};

	onAssignedUsersChanged = async ({ selectedUsers }) => {
		let newAssignedUsers = selectedUsers.slice();

		await this.update({
			assignedUsers: newAssignedUsers
		});
	};

	getMissingRequiredFields = () => {
		const { name, clientId, deadline, description, queueForNextRecurring } = this.state;
		const missing = [];
		if (!name?.trim()) missing.push("Task Name");
		// A queued task inherits its client from the engagement it materializes on
		if (!clientId && !queueForNextRecurring) missing.push("Client");
		if (!deadline) missing.push("Deadline");
		if (!description) missing.push("Description");
		return missing;
	};
    	
	onDescriptionChange = (html) => {
		this.update({ description: html });
	};
	
	render() {
		let {
			// Render state variables
			show,
			loading,

			// Data state variables
			name,
			description,
			deadline,
			// notes,
			createdBy,
			notify,
			assignedUsers,
			// read,

			// Temp data render state variables
			selectedStatus,
			selectedClientName,

			engagement,

			queueForNextRecurring
		} = this.state;
		let userData = UserService.getUserData();

		return (
			<>
				<Modal open={show} onClose={() => this.onClose({ confirmed: false })} center>
					<div className="task-modal">
						<div className="modal-title">{this.isNewTask() ? "New Task" : name}</div>

						<div className="task-modal__body">
							{loading && (
								<div className="container-loader">
									<Loader />
								</div>
							)}
							{!loading && (
								<>
									{this.state.sentBackReason && (
										<div className="task-modal__body__sent-back ft-task-sent-back">
											<Icon.CornerDownLeft size={14} />
											<span>Sent back: {this.state.sentBackReason}</span>
										</div>
									)}

									{!queueForNextRecurring && (
										<SearchableDropdown
											containerClass="task-modal__body__input"
											title={<RequiredLabel text="Client" />}
											onSelect={this.onClientSelect}
											type={"clients"}
											selectedName={selectedClientName}
											className="ft-task-client"
										/>
									)}

									<TextFieldInput
										containerClass="task-modal__body__input"
										title={<RequiredLabel text="Task Name" />}
										name="name"
										onChange={this.onChange}
										value={name}
										autoComplete="off"
										className="ft-task-name"
									/>

									<DescriptionField
										containerClass="task-modal__body__input"
										label={<RequiredLabel text="Description" />}
										value={description}
										onChange={this.onDescriptionChange}
										inputClassName="ft-task-desc"
									/>

									<SearchableDropdown
										containerClass="task-modal__body__input"
										title="Status"
										onSelect={this.onStatusSelect}
										type={"taskStatuses"}
										selectedName={selectedStatus}
										showAll
										className="ft-task-status"
									/>

									<DateSelector
										containerClass="task-modal__body__input"
										title={<RequiredLabel text="Deadline" />}
										selectedDate={new Date(deadline)}
										onDateSelect={this.onDeadlineChange}
										dateFormat={"MMMM d, yyyy h:mm aa"}
										showTimeSelect={true}
										className="ft-task-deadline"
									/>

									{/* <TextAreaField title="Notes" type="text" name="notes" value={notes} onChange={this.onChange} /> */}
									{(userData.userId === createdBy || this.isNewTask()) && (
										<Checkbox
											containerClass="task-modal__body__input"
											title="Notify me when this task is completed"
											name="notify"
											checked={notify}
											onChange={this.onChange}
											className="ft-task-notify"
										/>
									)}

									{this.isNewTask() && this.props.recurringEngagement && (
										<div className="task-modal__queue-recurring">
											<Checkbox
												title="Save for the next recurring engagement"
												name="queueForNextRecurring"
												checked={queueForNextRecurring}
												onChange={this.onChange}
												className="ft-task-queue-recurring"
											/>
											<Tooltip
												arrow
												position="top"
												title="This task will not be added to the current engagement. It will be saved on the recurrence schedule and automatically added to the next engagement generated by it. The client is inherited from that engagement, so you don't need to select one. Until then, you can view or remove it from the engagement's Repeat tab."
											>
												<Icon.Info className="task-modal__queue-recurring__info-icon" size={15} />
											</Tooltip>
										</div>
									)}

									{/* <TextAreaField title="Notes" type="text" name="notes" value={notes} onChange={this.onChange} /> */}

									<UserAssigner onChange={this.onAssignedUsersChanged} users={assignedUsers} showNotificationToggle />

									{this.state.showSendBack && (
										<div className="task-modal__body__send-back ft-task-send-back">
											<TextAreaField
												title="Reason for sending back"
												name="sendBackDraft"
												value={this.state.sendBackDraft}
												onChange={this.onSendBackDraftChange}
												className="ft-task-send-back-reason"
											/>
											<div className="task-modal__body__send-back__actions">
												<Button text="Cancel" view="secondary" onClick={this.onSendBackToggle} className="ft-task-send-back-cancel" />
												<Button
													text="Confirm send back"
													onClick={this.onSendBackConfirm}
													className="ft-task-send-back-confirm"
													disabled={this.state.loading}
												/>
											</div>
										</div>
									)}
								</>
							)}
						</div>
					</div>

					<div className="modal-footer">
					<PermissionGate resource="task" action="delete">  
						{!this.isNewTask() && <Button view="secondary" icon={<Icon.Trash2 size={18} />} onClick={this.onClickDelete} />}
					</PermissionGate>
					{this.canSendBack() && (
						<PermissionGate resource="task" action="update">
							<Button
								text="Send back"
								view="secondary"
								onClick={this.onSendBackToggle}
								className="ft-task-send-back-btn"
								disabled={this.state.loading}
							/>
						</PermissionGate>
					)}
					<PermissionGate resource="task" action="cancel">
						<Button text="Cancel" view="secondary" onClick={() => this.onClose({ confirmed: false })} className="ft-task-cancel-btn" />
					</PermissionGate>
					{this.isNewTask() && (
						<PermissionGate resource="task" action="create">
							<Button
								text={"Create"}
								onClick={() => this.onClose({ confirmed: true })}
								className="ft-task-create-update-btn"
								disabled={this.state.loading}
							/>
						</PermissionGate>
					)}
					{!this.isNewTask() && (
						<PermissionGate resource="task" action="update">
							<Button
								text={"Update"}
								onClick={() => this.onClose({ confirmed: true })}
								className="ft-task-create-update-btn"
								disabled={this.state.loading}
							/>
						</PermissionGate>
					)}
					</div>
				</Modal>

				<DeleteConfirmationModal
					title="Delete Task?"
					warning="Are you sure you want to delete this task?"
					show={this.state.showDeleteConfirmation}
					onClose={this.onClickDeleteConfirm}
				/>
			</>
		);
	}
}

export default TaskModal;
